import React, { useState, useEffect } from 'react';
import { productsAPI, alertsAPI } from '../api/client';
import '../styles/alert.css';

const parseProductSizes = (sizesStr) => {
  if (!sizesStr) return [];
  return sizesStr.split(' ')
    .map(p => { const [s, q] = p.split(':'); return q && parseInt(q) > 0 ? s : null; })
    .filter(Boolean);
};

const RestockAlertModal = ({ product, onClose, existingAlert, onAlertChange }) => {
  const [size, setSize] = useState('');
  const [contact, setContact] = useState('');
  const [excluded, setExcluded] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const sizes = parseProductSizes(product.sizes);

  useEffect(() => {
    productsAPI.getSuppliers(product.id).then(r => {
      const names = [...new Set((r.data || []).map(s => s.supplier_name).filter(Boolean))];
      setSuppliers(names);
    }).catch(() => {});
  }, [product.id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!size) { setError('Выберите размер'); return; }
    setSubmitting(true);
    setError('');
    try {
      await alertsAPI.create({
        product_sku: product.sku,
        size,
        contact: contact.trim() || null,
        excluded_suppliers: excluded,
      });
      setDone(true);
      onAlertChange && onAlertChange();
      setTimeout(onClose, 1800);
    } catch {
      setError('Ошибка при сохранении');
    } finally {
      setSubmitting(false);
    }
  };

  const handleCancel = async () => {
    if (!existingAlert) return;
    setSubmitting(true);
    try {
      await alertsAPI.delete(existingAlert.id);
      onAlertChange && onAlertChange();
      onClose();
    } catch {
      setError('Ошибка при отмене');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="alert-overlay" onClick={onClose}>
      <div className="alert-modal" onClick={e => e.stopPropagation()}>
        <div className="alert-header">
          <span>🔔 Уведомление о поступлении</span>
          <button className="alert-close" onClick={onClose}>×</button>
        </div>

        {done ? (
          <div className="alert-success">✓ Подписка оформлена! Уведомим при поступлении.</div>
        ) : existingAlert ? (
          <div className="alert-existing">
            <p>Активная подписка: размер <b>{existingAlert.size}</b></p>
            {existingAlert.contact && <p className="alert-muted">Контакт: {existingAlert.contact}</p>}
            <div className="alert-footer">
              <button className="alert-btn-cancel" onClick={handleCancel} disabled={submitting}>
                Отменить подписку
              </button>
              <button className="alert-btn-ghost" onClick={onClose}>Закрыть</button>
            </div>
          </div>
        ) : (
          <form className="alert-form" onSubmit={handleSubmit}>
            <div className="alert-field">
              <label>Артикул</label>
              <input type="text" value={product.sku} readOnly className="alert-input alert-input--readonly" />
            </div>

            <div className="alert-field">
              <label>Размер *</label>
              {sizes.length > 0 ? (
                <select className="alert-input" value={size} onChange={e => setSize(e.target.value)} required>
                  <option value="">— выберите —</option>
                  {sizes.map(s => <option key={s} value={s}>{s}</option>)}
                </select>
              ) : (
                <input
                  type="text"
                  className="alert-input"
                  placeholder="например: 42"
                  value={size}
                  onChange={e => setSize(e.target.value)}
                  required
                />
              )}
            </div>

            <div className="alert-field">
              <label>Контакт клиента</label>
              <input
                type="text"
                className="alert-input"
                placeholder="Телефон, ссылка или имя"
                value={contact}
                onChange={e => setContact(e.target.value)}
              />
            </div>

            {suppliers.length > 0 && (
              <div className="alert-field">
                <label>Исключить поставщиков</label>
                <div className="alert-checkbox-list">
                  {suppliers.map(name => (
                    <label key={name} className="alert-checkbox-item">
                      <input
                        type="checkbox"
                        checked={excluded.includes(name)}
                        onChange={e => setExcluded(prev =>
                          e.target.checked ? [...prev, name] : prev.filter(n => n !== name)
                        )}
                      />
                      {name}
                    </label>
                  ))}
                </div>
              </div>
            )}

            {error && <div className="alert-error">{error}</div>}

            <div className="alert-footer">
              <button type="submit" className="alert-btn-submit" disabled={submitting}>
                {submitting ? 'Сохраняем...' : 'Сообщить о поступлении'}
              </button>
              <button type="button" className="alert-btn-ghost" onClick={onClose}>Отмена</button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default RestockAlertModal;
